export default class Articles {
	static init() {
		/***
		 * Specialhantering för bilder i long reads.
		 * Gör brödtextbilder bredare.
		 */
		$('.o-longRead p').each(function () {
			if ($(this).find('.u-ratio').length > 0) {
				// The p element has a child with the u-ratio class
				// You can apply styles or classes to it here
				$(this).addClass('wide-image');
			}
		});
	}
}
